/**
 * custom.js
 *
 * This file handles custom JavaScript functionalities for the website.
 * Organized into sections for easier maintenance and scalability.
 */

/**
 * =========================
 * Section 1: Carousel Banner
 * =========================
 */

/**
 * Initializes the carousel functionality for the mobile version of the banner.
 * Cycles through messages every 3 seconds.
 */

document.addEventListener("DOMContentLoaded", function () {
  const messages = document.querySelectorAll(".carousel-message");
  let currentIndex = 0;

  function showNextMessage() {
    messages[currentIndex].classList.remove("active");
    currentIndex = (currentIndex + 1) % messages.length;
    messages[currentIndex].classList.add("active");
  }

  if (messages.length) {
    setInterval(showNextMessage, 3000); // Change message every 3 seconds
  }
});

/**
 * =========================
 * Section 2: Review Star Ratings
 * =========================
 */

/**
 * Implements clickable star ratings for reviews.
 * Updates the functionality of the Judge.me Shopify app.
 */

window.addEventListener("load", function () {
  // Select all star elements inside the container
  const stars = document.querySelectorAll(
    ".jdgm-rev-widg__summary-stars .jdgm-star"
  );

  // Loop through each star and add event listeners, keeping track of its index
  stars.forEach(function (star, index) {
    star.addEventListener("mouseenter", function () {
      // Loop through all stars and update classes based on hovered index
      stars.forEach(function (s, i) {
        if (i <= index) {
          s.classList.remove("jdgm--off");
          s.classList.add("jdgm--on");
        } else {
          s.classList.remove("jdgm--on");
          s.classList.add("jdgm--off");
        }
      });
    });

    star.addEventListener("mouseleave", function () {
      // Reset all stars on mouse leave (optional)
      stars.forEach(function (s) {
        s.classList.remove("jdgm--on");
        s.classList.add("jdgm--off");
      });
    });

    // Log the star number when clicked
    star.addEventListener("click", function () {
      // Using (index + 1) if you want to count stars from 1 instead of 0
      document.querySelector(".jdgm-write-rev-link").click();

      const nthChild = document.querySelector(
        ".jdgm-form__rating > :nth-child(" + (index + 1) + ")"
      );
      nthChild.click();
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Run our one-time code when on /cart
  runOnceAfterCart();

  const urlParams = new URLSearchParams(window.location.search);
  const discountInput = document.getElementById("discount-input");
  const applyDiscountButton = document.getElementById("apply-discount");
  const appliedDiscountDisplay = document.getElementById("applied-discount");
  const removeDiscountButton = document.getElementById("remove-discount");

  // Update the discount display (currently not used)
  function updateDisplay() {
    const savedDiscount = localStorage.getItem("appliedDiscount");
    // Placeholder for future use if needed
  }

  // Initial display check
  updateDisplay();

  // Function to add a product to the cart
  function addProductToCart(productId, quantity, discountInputValue) {
    const formData = {
      items: [
        {
          id: productId,
          quantity: quantity,
        },
      ],
    };

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Item added to the cart:", data);
        // Clear the session storage to allow the message to show again
        sessionStorage.removeItem("oneTimeCodeExecuted");
        // Redirect to /cart with a special query parameter so our one-time code runs
        //   window.location.href = '/cart?redirectedFromAdd=true';

        const redirectParams = new URLSearchParams({
          redirectedFromAdd: true,
          discount_code: discountInputValue,
        });
        const redirectUrl = `/cart?${redirectParams.toString()}`;
        window.location.href = `https://www.play-toys.co.uk/discount/${discountInputValue}?redirect=${encodeURIComponent(
          redirectUrl
        )}`;
      })
      .catch((error) => {
        console.error("Error adding product:", error);
      });
  }

  if (applyDiscountButton) {
    applyDiscountButton.addEventListener("click", function () {
      const discountInputValue = discountInput.value.trim();

      // Special case for a specific discount code
      if (discountInputValue === "FREESLIME") {
        console.log("Try to add the product now!");

        // Check if the product is already in the cart
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then((response) => response.json())
          .then((cart) => {
            const productId = 50133846655323;
            const productExists = cart.items.some(
              (item) => item.id === productId
            );

            if (!productExists) {
              // FREE SLIME PRODUCT
              addProductToCart(productId, 1, discountInputValue);
            } else {
              console.log("Product already exists in the cart.");
              // Optionally redirect or handle as needed
            }
          })
          .catch((error) => {
            console.error("Error checking cart:", error);
            // Fallback: try to add the product anyway
            addProductToCart(50133846655323, 1);
          });

        return;
      }
      // Updated discount code handling
      if (discountInputValue === "BUY1GET1") {
        console.log("BUY1GET1");

        fetch("/cart.js")
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Cart fetch error: ${response.statusText}`);
            }
            return response.json();
          })
          .then((cart) => {
            console.log("Cart items:", cart.items);

            // Fetch product details for each cart item and merge in cart-specific data.
            return Promise.all(
              cart.items.map((item) =>
                fetch(`/products/${item.handle}.json`)
                  .then((res) => {
                    if (!res.ok) {
                      throw new Error(
                        `Product fetch error for ${item.handle}: ${res.status}`
                      );
                    }
                    return res.json();
                  })
                  .then((productData) => ({
                    ...productData,
                    cartQuantity: item.quantity,
                    variant_id: item.variant_id,
                  }))
              )
            );
          })
          .then((products) => {
            console.log("Fetched product details:", products);

            // Filter products with the "bogo" tag
            const bogoItems = products.filter((product) =>
              product.product.tags.includes("bogo")
            );
            console.log("BOGO eligible items:", bogoItems);

            // Calculate total BOGO items and replacements
            const totalBogoItems = bogoItems.reduce(
              (sum, item) => sum + item.cartQuantity,
              0
            );
            const replacementCount = Math.floor(totalBogoItems / 2);
            console.log(
              `Total BOGO items: ${totalBogoItems}, Replacements needed: ${replacementCount}`
            );

            // Sort BOGO items by price (lowest first)
            const sortedBogoItems = bogoItems.slice().sort((a, b) => {
              const priceA = parseFloat(a.product.variants[0].price);
              const priceB = parseFloat(b.product.variants[0].price);
              return priceA - priceB;
            });

            // Select items to replace considering quantities
            let remainingReplacements = replacementCount;
            const itemsToReplace = [];
            for (const item of sortedBogoItems) {
              if (remainingReplacements <= 0) break;
              const quantityAvailable = item.cartQuantity;
              const quantityToTake = Math.min(
                quantityAvailable,
                remainingReplacements
              );
              itemsToReplace.push({ item, quantity: quantityToTake });
              remainingReplacements -= quantityToTake;
            }

            // Fetch free alternatives
            return Promise.all([
              Promise.resolve(itemsToReplace),
              fetch("/collections/all/products.json?limit=250").then((res) => {
                if (!res.ok) {
                  throw new Error(
                    `Free alternatives fetch error: ${res.statusText}`
                  );
                }
                return res.json();
              }),
            ]);
          })
          .then(([itemsToReplace, allProducts]) => {
            const freeProducts = allProducts.products.filter((product) =>
              product.tags.includes("bogo-free")
            );
            console.log("Free alternative products available:", freeProducts);

            // Create replacement mapping with quantities
            const replacements = itemsToReplace
              .map(({ item, quantity }) => {
                const freeTitle = item.product.title + " Free";
                const freeAlternative = freeProducts.find(
                  (fp) => fp.title === freeTitle
                );
                return {
                  original: item,
                  freeAlternative: freeAlternative || null,
                  quantity: quantity,
                };
              })
              .filter((rep) => rep.freeAlternative !== null);

            console.log("Replacement mapping:", replacements);
            return updateCartWithReplacements(replacements);
          })
          .catch((error) =>
            console.error("Error fetching cart or products:", error)
          );

        return;
      }

      const otherDiscounts = ["FREESOCIALS"];

      // For other discount codes, redirect to the discount URL
      if (discountInputValue && otherDiscounts.includes(discountInputValue)) {
        sessionStorage.removeItem("oneTimeCodeExecuted");
        // Redirect to /cart with a special query parameter so our one-time code runs
        //   window.location.href = '/cart?redirectedFromAdd=true';

        const redirectParams = new URLSearchParams({
          redirectedFromAdd: true,
          discount_code: discountInputValue,
        });
        const redirectUrl = `/cart?${redirectParams.toString()}`;
        window.location.href = `https://www.play-toys.co.uk/discount/${discountInputValue}?redirect=${encodeURIComponent(
          redirectUrl
        )}`;

        // window.location.href = `https://www.play-toys.co.uk/discount/${discountInputValue}?redirect=/cart?redirectedFromAdd=true&discount_code=${discountInputValue}`;
      }
    });
  }

  // Event listener for applying discount
});

// Helper function to update the Shopify cart with free alternatives.
async function updateCartWithReplacements(replacements) {
  console.log("Replacements received", {
    replacements: JSON.stringify(replacements),
  });

  try {
    // Fetch the current cart once
    const cart = await fetch("/cart.js").then((response) => response.json());
    console.log("Cart items:", cart.items);

    // Process each replacement sequentially
    for (const replacement of replacements) {
      // Add the free alternative product with quantity
      await new Promise((resolve, reject) => {
        addItemToCart(
          replacement.freeAlternative.variants[0].id,
          replacement.quantity,
          (data) => {
            console.log(`${replacement.quantity} items added to cart:`, data);
            resolve(data);
          }
        );
      });

      // Find original item using initial cart data
      const originalItem = cart.items.find(
        (item) => item.variant_id === replacement.original.variant_id
      );

      if (!originalItem) {
        console.warn("Original item not found, skipping adjustment.");
        continue;
      }

      // Calculate new quantity after replacement
      const newQuantity = originalItem.quantity - replacement.quantity;

      if (newQuantity > 0) {
        // Update the original item's quantity
        await new Promise((resolve, reject) => {
          updateCartItemQuantity(originalItem.key, newQuantity, (data) => {
            console.log("Item quantity updated:", data);
            resolve(data);
          });
        });
      } else {
        // Remove the original item
        console.log("Now removing item from cart:", originalItem.key);
        await new Promise((resolve, reject) => {
          removeItemFromCart(originalItem.key, (data) => {
            console.log("Item removed from cart:", data);
            resolve(data);
          });
        });
      }
    }

    // Cleanup and redirect after all replacements
    sessionStorage.removeItem("oneTimeCodeExecuted");
    const redirectParams = new URLSearchParams({
      redirectedFromAdd: true,
      discount_code: "BUY1GET1",
    });
    const redirectUrl = `/cart?${redirectParams.toString()}`;
    window.location.href = `https://www.play-toys.co.uk/discount/BUY1GET1?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  } catch (error) {
    console.error("Error updating cart:", error);
  }
}

// Helper functions (add these if not already present)
function addItemToCart(variantId, quantity, callback) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: quantity }],
    }),
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => console.error("Error:", error));
}

function removeItemFromCart(key, callback) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: key,
      quantity: 0,
    }),
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => console.error("Error removing product:", error));
}

function updateCartItemQuantity(lineItemKey, newQuantity, callback) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: lineItemKey,
      quantity: newQuantity,
    }),
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => console.error("Error:", error));
}

function runOnceAfterCart() {
  const urlParams = new URLSearchParams(window.location.search);

  console.log("Running one-time code on /cart page...", {
    firstParam: urlParams.has("redirectedFromAdd"),
    secondParam: !sessionStorage.getItem("oneTimeCodeExecuted"),
  });

  // Only run if the user was redirected from add-to-cart and the code hasn't run yet
  if (
    urlParams.has("redirectedFromAdd") &&
    !sessionStorage.getItem("oneTimeCodeExecuted")
  ) {
    console.log(
      "Running one-time code on /cart page from add-to-cart redirect..."
    );
    const messageDiv = document.getElementById("free-slime-kit-message");
    if (messageDiv) {
      if (
        urlParams.has("discount_code") &&
        urlParams.get("discount_code") === "BUY1GET1"
      ) {
        messageDiv.innerHTML =
          "Buy 1 Get 1 Free discount code applied successfully!";
      } else if (
        urlParams.has("discount_code") &&
        urlParams.get("discount_code") !== "FREESLIME"
      ) {
        messageDiv.innerHTML = "Discount code applied successfully!";
      } else {
        messageDiv.innerHTML =
          "Discount code applied successfully! Free Slime Kit was added to your cart.";
      }

      messageDiv.style.display = "block";
    }
    // Mark the code as executed so it doesn't run on subsequent refreshes
    sessionStorage.setItem("oneTimeCodeExecuted", "true");

    // Optionally, remove the query parameter so subsequent refreshes don't trigger the logic again
    urlParams.delete("redirectedFromAdd");
    const newUrl =
      window.location.pathname +
      (urlParams.toString() ? "?" + urlParams.toString() : "");
    window.history.replaceState(null, "", newUrl);
  }
}

document.addEventListener("DOMContentLoaded", runOnceAfterCart);
